import { Components } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import styled from "styled-components";

import { API_PATHS } from "../../../../API/api_paths";
import { useAppSelector } from "../../../../redux";
import { ArticleProps } from "../../../../redux/slices/article/Article";
import {
  getImageBase64,
  validFile,
  validImageFileTypes,
} from "../../../../utils";
import Upload from "./upload";
import CropImageModal from "./cropImageModal";

const CoverImage = () => {
  const [imageUrl, setImageUrl] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const { content_data } = useAppSelector(
    (state) =>
      state.article.draftArticle.cover_image as ArticleProps.WithImageContent
  );

  return (
    <>
      {content_data?.[0]?.id && content_data?.[0]?.size > 0 ? (
        <Container>
          <Image
            src={
              API_PATHS.posts.getPostImage +
              content_data?.[0]?.id +
              `?${content_data?.[0]?.updated_at}`
            }
          />
          <ButtonWrapper>
            <Components.IconButton
              iconType="Edit"
              disabled={false}
              size="Small"
              kind="Opacity"
              onClick={() => {
                fileInputRef.current?.click();
              }}
            />
          </ButtonWrapper>
        </Container>
      ) : (
        <Upload
          fileInputRef={fileInputRef}
          setIsCropModalOpen={setIsCropModalOpen}
          setImageUrl={setImageUrl}
        />
      )}
      {isCropModalOpen && (
        <CropImageModal
          imageUrl={imageUrl}
          setIsCropModalOpen={setIsCropModalOpen}
          onImageUpload={() => {
            fileInputRef.current?.click();
          }}
        />
      )}
      <HiddenInput
        type="file"
        disabled={false}
        onChange={(e) => {
          const files = e.target.files;
          if (!files?.length) return;
          const validFiles = validFile(files);
          if (!validFiles.length) return;
          getImageBase64(validFiles[0]).then((url) => {
            setImageUrl(url);
            setIsCropModalOpen(true);
          });
          e.target.value = "";
        }}
        ref={fileInputRef}
        accept={validImageFileTypes.join(",")}
      />
    </>
  );
};

export default CoverImage;

const Image = styled.img`
  width: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 906px;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
`;

const HiddenInput = styled.input`
  display: none;
`;
